// ONDEMAND-1: AdminScreen's "Transcription on demand" card — what deferring transcription saved
// this month. Every figure comes from the server (`AdminUsage.on_demand`); durations and money
// are estimates and are labelled as such. Rendered only when `on_demand` is present (null =
// feature off).
import type { OnDemandSavings } from '@scribe/core/types';
import { formatUsd } from '../ui';

function Stat({ label, value, note }: { label: string; value: string; note?: string }) {
  return (
    <div className="admin-summary-card">
      <span className="admin-summary-label">{label}</span>
      <span className="admin-summary-value">{value}</span>
      {note && <span className="muted">{note}</span>}
    </div>
  );
}

export function OnDemandSavingsCard({ savings }: { savings: OnDemandSavings }) {
  const untranscribedMin = Math.round(savings.never_transcribed_seconds / 60);
  return (
    <section className="row-secondary" aria-label="Transcription on demand">
      <h2>Transcription on demand</h2>
      <div className="admin-summary">
        <Stat label="Deferred this month" value={savings.deferred_count.toLocaleString()} />
        <Stat
          label="Still untranscribed"
          value={savings.never_transcribed_count.toLocaleString()}
          note={`≈${untranscribedMin.toLocaleString()} min (estimated)`}
        />
        <Stat
          label="Transcribed on access"
          value={savings.transcribed_on_access_count.toLocaleString()}
        />
        <Stat
          label="Estimated savings"
          value={formatUsd(savings.estimated_savings_usd)}
          note="estimated"
        />
        <Stat
          label="Summaries not generated"
          value={savings.summaries_missing_count.toLocaleString()}
        />
        <Stat
          label="Summaries generated on access"
          value={savings.summaries_on_access_count.toLocaleString()}
        />
      </div>
    </section>
  );
}
